export default {
  header: {
    collection: 'Collection',
    discord: 'Rejoindre Discord',
    twitter: 'Suivre sur Twitter',
  },
  landing: {
    discover: 'Découvrez',
    nodeRocks: 'NODE_ROCKS',
    onBitcoin: 'sur Bitcoin',
    searchPlaceholder: 'Entrez l\'ID du Rock...',
    viewDetails: 'Voir les Détails',
  },
  story: {
    title: 'L\'Histoire Derrière NodeRocks',
    description: 'NodeRocks a débuté en décembre, créé par un développeur connu sous le nom de {{developer}}. Cependant, lorsque le projet a fait face à un possible rug pull, la communauté a refusé de le laisser mourir. Au lieu de cela, ils se sont rassemblés, ont pris le contrôle et ont commencé à reconstruire le projet depuis le début.',
    community: 'La communauté a rapidement obtenu l\'accès au portail des développeurs {{platform}} et a lancé de nouveaux canaux de médias sociaux pour se reconnecter et grandir. En quelques semaines, NodeRocks était plus fort que jamais, et la communauté a commencé à construire des fonctionnalités passionnantes comme leur propre plateforme de staking, explorateur et même à créer de la musique pour le projet.',
    conclusion: 'NodeRocks est maintenant le premier projet 100% dirigé par la communauté dans l\'espace Ordinals, un témoignage de la puissance d\'une communauté passionnée qui s\'unit pour pousser le projet vers de nouveaux sommets. D\'un quasi-effondrement à une communauté prospère et innovante, NodeRocks est devenu un symbole de résilience et de créativité dans le monde des Bitcoin Ordinals.',
  },
  yinYang: {
    title: 'Inscriptions Yin Yang',
    subtitle: 'Symbole d\'Harmonie sur Bitcoin pour toujours on-chain',
    history: {
      title: 'Histoire',
      description: 'Parmi les Inscriptions Maudites, un phénomène unique est apparu lorsque les inscriptions {{positive}} et {{negative}} ont été liées au même satoshi. Ce jumelage est venu symboliser la dualité et l\'harmonie, s\'inspirant de l\'ancienne philosophie chinoise du Yin et du Yang.',
    },
    rarity: {
      title: 'Quelle est la Rareté des Inscriptions Yin Yang ?',
      description: 'Il n\'y a que {{count}} inscriptions Yin Yang pour toujours sur Bitcoin, ce qui en fait un sous-ensemble incroyablement rare des {{total}} Inscriptions Maudites totales. Leur création a cessé après le {{block}} en 2024, solidifiant leur rareté.',
    },
  },
  cursedRocks: {
    title: 'La Dualité des Rocks Maudits',
    subtitle: 'Un Chapitre Unique dans Bitcoin Ordinals',
    normal: 'Normal',
    cursed: 'Maudit',
    hoverReveal: 'Survolez pour révéler la malédiction',
    whatAre: {
      title: 'Rocks Maudits ?',
      description: 'Chaque NodeRock est accompagné de son homologue Maudit, les deux étant stockés de manière unique sur le même satoshi. Le NodeRock représente l\'inscription positive, tandis que le Rock Maudit sert de contrepartie négative. Ensemble, ils forment un parfait équilibre Yin Yang, symbolisant la dualité et l\'interconnexion.',
    },
    rarity: {
      title: 'Rareté & Valeur',
      description: 'NodeRocks est la première collection à proposer un concept Achetez 1, Obtenez 2, où chaque NodeRock est accompagné de son Rock Maudit apparié, formant un équilibre Yin Yang. Avec seulement 70 000 inscriptions Yin Yang jamais créées, il n\'y aura plus jamais de nouvelles inscriptions Yin Yang, faisant de chaque paire un actif exclusif et rare.',
    },
  },
  laboratory: {
    title: 'STAKEZ VOS NODEROCKS !',
    stakeNow: 'STAKER MAINTENANT',
  },
  showcase: {
    title: 'Présentez Votre Rock',
    subtitle: 'Rejoignez la révolution de l\'art numérique sur Bitcoin',
    viewCollection: 'Voir la Collection Complète',
  },
  footer: {
    language: 'Langue',
    selectLanguage: 'Sélectionner la Langue',
    links: 'Liens Rapides',
    marketplace: 'Marché Magic Eden',
    discord: 'Rejoindre Discord',
    twitter: 'Suivre sur Twitter',
    community: 'Communauté',
    rights: 'Tous droits réservés.',
  },
};